import store from "../store";
import SettingsModule from '@/modules/settings';
import {Role} from "@/modules/core/data/roles";
import BookModule from '@/modules/book';
import DisplayModule from '@/modules/display';
import CoreModule from '@/modules/core';

export default class ModuleSwitcher {

  static installModules() {
    //install the modules
    CoreModule.install();
    BookModule.installRoutes();
    SettingsModule.installRoutes();
    DisplayModule.installRoutes();
    this.switchModule(window.location.pathname);
  }

  static switchModule(url) {
    let currentModule = store.state.manager.module;
    let moduleByPath = this.getModuleNameByPath(url);

    if (currentModule !== moduleByPath) {
      switch (moduleByPath) {
        case store.state.manager.displayModuleName:
          if (!store.hasModule(store.state.manager.displayModuleName)) {
            DisplayModule.install();
          }
          currentModule = store.state.manager.displayModuleName;
          break;
        case store.state.manager.settingsModule:
          if (!store.hasModule(store.state.manager.settingsModule)) {
            SettingsModule.install();
          }
          currentModule = store.state.manager.settingsModule;
          break
        case store.state.manager.bookModuleName:
          if (!store.hasModule(store.state.manager.bookModuleName)) {
            BookModule.install();
          }
          currentModule = store.state.manager.bookModuleName;
          break
        case 'core':
          currentModule = 'core';
      }

      store.commit('manager/changeModule', currentModule);
    }
  }

  static getModuleNameByPath(path) {

    let currentUrlArray = path.substring(1).split('/');
    let module = 'core';

    if (currentUrlArray.length > 0 && this.isDisplayModule(currentUrlArray[0])) {
      module = store.state.manager.displayModuleName;
    } else if (currentUrlArray.length > 0 && currentUrlArray[0] === store.state.manager.settingsModule) {
      module = store.state.manager.settingsModule;
    } else if (currentUrlArray.length > 0 && currentUrlArray[0] === store.state.manager.bookModuleUrl) {
      module = store.state.manager.bookModuleName;
    }

    return module;
  }

  static isDisplayModule(currentUrl) {
    let disaplayModuleUrls = [
        'register'
    ]
    return currentUrl === store.state.manager.displayModuleUrl || disaplayModuleUrls.indexOf(currentUrl) > -1;

  }

  static redirectIfNeeds() {
    let currentUser = store.state.auth.user;

    if (!currentUser) {
      return;
    }

    if (currentUser.roles.includes(Role.Admin)) {
      return;
    }

    if (ModuleSwitcher.isOnlyLiftBook()) {
      window.location.replace(`/${store.state.manager.bookModuleUrl}`);
    } else if (ModuleSwitcher.isOnlyDisplay()) {
      window.location.replace(ModuleSwitcher.getDisplayHomeUrl());
    }
  }

  static getDisplayHomeUrl() {
    let currentUser = store.state.auth.user;
    let url = `/${store.state.manager.displayModuleUrl}/elevator`;

    if (currentUser.roles.includes(Role.ViewEmployee)) {
      url = `/${store.state.manager.displayModuleUrl}`;
    } else if (currentUser.roles.includes(Role.Master)) {
      url = `/${store.state.manager.displayModuleUrl}/offer`;
    }

    return url;
  }

  static isOnlyLiftBook() {
    let currentUser = store.state.auth.user;
    return (!currentUser.roles.includes(Role.FacilityManager)
        && !currentUser.roles.includes(Role.Master)
        && !currentUser.roles.includes(Role.ViewEmployee))
      && (
        currentUser.roles.includes(Role.Operator)
        || currentUser.roles.includes(Role.Manager)
        || currentUser.roles.includes(Role.Worker));
  }

  static isOnlyDisplay() {
    let currentUser = store.state.auth.user;
    return (!currentUser.roles.includes(Role.Operator)
        && !currentUser.roles.includes(Role.Manager)
        && !currentUser.roles.includes(Role.Worker))
      && (currentUser.roles.includes(Role.FacilityManager)
        || currentUser.roles.includes(Role.Master)
        || currentUser.roles.includes(Role.ViewEmployee));
  }
}